/**
 * The top bar's outlined pill (Figma "App Bar" actions), shared by the
 * draft-status badge and the app switch so the two cannot drift. Below `sm`
 * callers collapse their label to icon-only so the breadcrumb keeps its room.
 */
export const TOP_BAR_PILL_CLASS =
  'flex h-8 items-center gap-1.5 rounded-lg border border-border bg-card px-2 text-body-sm-medium text-foreground sm:px-3.5';
